import { render, staticRenderFns } from "./uploadForm.vue?vue&type=template&id=5923e0bc&scoped=true&"
import script from "./uploadForm.vue?vue&type=script&lang=js&"
export * from "./uploadForm.vue?vue&type=script&lang=js&"
import style0 from "./uploadForm.vue?vue&type=style&index=0&id=5923e0bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5923e0bc",
  null
  
)

export default component.exports